// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22CyH","title":"Info_title__QawdD","links":"Info_links__1nM03","link":"Info_link__1DamZ","logo":"Info_logo__33ceN"};